import { useStaticQuery, graphql } from 'gatsby';

import { isBrowser } from 'helpers/isBrowser';
import { testingSiteMetadata } from 'data/siteMetadata';
import type { SiteMetadataGraphQL, SiteMetadata } from './types';

const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        siteUrl
        helpUrl
        appUrl
        communityUrl
      }
    }
  }
`;

export const useSiteMetadata = (): SiteMetadata => {
  const { site }: SiteMetadataGraphQL = useStaticQuery(query);

  if (isBrowser && window.location.href.includes(testingSiteMetadata.siteUrl)) {
    return {
      siteUrl: testingSiteMetadata.siteUrl,
      helpUrl: testingSiteMetadata.helpUrl,
      appUrl: testingSiteMetadata.appUrl,
      communityUrl: testingSiteMetadata.communityUrl,
    };
  }

  return {
    siteUrl: site.siteMetadata.siteUrl,
    helpUrl: site.siteMetadata.helpUrl,
    appUrl: site.siteMetadata.appUrl,
    communityUrl: site.siteMetadata.communityUrl,
  };
};
